import { createContext } from 'react';

const TrainTrackingContext = createContext();

export default TrainTrackingContext;
